import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { AlertTriangle } from "lucide-react";
import { Link } from "react-router-dom";

const fmt4 = (n) => Number(n ?? 0).toLocaleString("tr-TR", { minimumFractionDigits: 4, maximumFractionDigits: 4 });

export default function StockAlerts() {
  const [alerts, setAlerts] = useState([]);
  useEffect(() => { api.get("/stock/alerts").then(r => setAlerts(r.data)); }, []);

  const critical = alerts.filter(a => a.severity === "critical");
  const warning = alerts.filter(a => a.severity === "warning");

  return (
    <div className="space-y-6" data-testid="stock-alerts-page">
      <div>
        <div className="label-caps">Stok Kontrol</div>
        <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl mt-2 font-light">Stok Uyarıları</h1>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="card-flat p-6 border-red-500/40" style={{borderColor:"rgba(239,68,68,0.4)"}}>
          <div className="flex items-center gap-2 mb-2"><AlertTriangle className="text-red-400" size={16} /><div className="label-caps text-red-400">Tükendi ({critical.length})</div></div>
          <div className="font-display text-2xl mb-4">Kritik</div>
          <div className="divide-y divide-white/5">
            {critical.map(p => (
              <div key={p.id} className="py-3 flex justify-between">
                <div>
                  <div className="text-sm">{p.name}</div>
                  <div className="label-caps mt-1 font-mono">{p.barcode}</div>
                </div>
                <div className="font-mono text-red-400">0</div>
              </div>
            ))}
            {critical.length === 0 && <div className="py-4 text-sm text-neutral-500">Kritik ürün yok — iyi haber!</div>}
          </div>
        </div>

        <div className="card-flat p-6">
          <div className="flex items-center gap-2 mb-2"><AlertTriangle style={{color:"var(--gold)"}} size={16} /><div className="label-caps" style={{color:"var(--gold)"}}>Az Kaldı ({warning.length})</div></div>
          <div className="font-display text-2xl mb-4">Dikkat</div>
          <div className="divide-y divide-white/5">
            {warning.map(p => (
              <div key={p.id} className="py-3 flex justify-between">
                <div>
                  <div className="text-sm">{p.name}</div>
                  <div className="label-caps mt-1 font-mono">{p.barcode} · Eşik {p.threshold}</div>
                </div>
                <div className="font-mono" style={{color:"var(--gold)"}}>{p.stock}</div>
              </div>
            ))}
            {warning.length === 0 && <div className="py-4 text-sm text-neutral-500">Uyarı yok</div>}
          </div>
        </div>
      </div>

      <div className="text-center">
        <Link to="/products" className="btn-gold inline-block">Tüm Ürünlere Git</Link>
      </div>
    </div>
  );
}
